package com.shadowings.gero.data.lessons.chapter11

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_complementi_complessi_1
import gero.composeapp.generated.resources.exp_content_complementi_complessi_10
import gero.composeapp.generated.resources.exp_content_complementi_complessi_2
import gero.composeapp.generated.resources.exp_content_complementi_complessi_3
import gero.composeapp.generated.resources.exp_content_complementi_complessi_4
import gero.composeapp.generated.resources.exp_content_complementi_complessi_5
import gero.composeapp.generated.resources.exp_content_complementi_complessi_6
import gero.composeapp.generated.resources.exp_content_complementi_complessi_7
import gero.composeapp.generated.resources.exp_content_complementi_complessi_8
import gero.composeapp.generated.resources.exp_content_complementi_complessi_9
import gero.composeapp.generated.resources.exp_title_complementi_complessi

fun getComplementiComplessiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_2,
            face = Faces.Sad,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_3,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_4,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_5,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_8,
            face = Faces.Serious,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "O1h2:Z1-M23-X1:N35-A41",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_9,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "N35:N35:N35-N35-O34h0.5:X1*B1",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_complementi_complessi,
            content = Res.string.exp_content_complementi_complessi_10,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
    )
}
